import { Backend } from '../Backend';
import { ISettingElementV1, ISettingValueV1 } from '../models/AndromeTV.types';

export class CustomerSettingsApi {
  /**
   * Retrieve all customer settings
   */
  static list(backend: Backend): Promise<ISettingElementV1[]> {
    const url = backend.makeUrl('history/v1/customer/settings');
    return backend.getJson(url, backend.bearer) as Promise<ISettingElementV1[]>;
  }

  /**
   * Retrieve the value for a specific setting
   */
  static value(backend: Backend, name: string): Promise<ISettingValueV1> {
    const url = backend.makeUrl(`history/v1/customer/settings/${encodeURIComponent(name)}`);
    return backend.getJson(url, backend.bearer) as Promise<ISettingValueV1>;
  }

  /**
   * Create or update the value for a specific setting
   */
  static update(backend: Backend, name: string, value: string): Promise<ISettingValueV1> {
    const url = backend.makeUrl(`history/v1/customer/settings/${encodeURIComponent(name)}`);
    return backend.putJson(url, { value: value }, backend.bearer) as Promise<ISettingValueV1>;
  }

  /**
   * Delete the setting with the specified name
   */
  static delete(backend: Backend, name: string): Promise<Response> {
    const url = backend.makeUrl(`history/v1/customer/settings/${encodeURIComponent(name)}`);
    return backend.delete(url, backend.bearer) as Promise<Response>;
  }
}
